var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.016 512.016",
    height: 512,
    viewBox: "0 0 512.016 512.016",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m475.278 99.896-40.73-32.13 3.38-51.77c.41-6.2-2.84-11.28-7.48-13.95-4.63-2.68-10.66-2.94-15.82.5l-43.14 28.8-48.2-19.2c-11.53-4.6-23.35 6.05-19.99 18l14.07 49.93-33.16 39.9c-7.94 9.55-1.46 24.09 10.94 24.58l51.84 2.05 27.69 43.87c6.65 10.52 22.47 8.79 26.76-2.81l17.97-48.67 50.28-12.79c12.03-3.06 15.34-18.63 5.59-26.31z",
    fill: "#fed843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.008 422.016h-131c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h131c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15z",
    fill: "#fed843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.008 362.016h-125c-8.284 0-15 6.716-15 15v135h140c8.284 0 15-6.716 15-15v-120c0-8.284-6.716-15-15-15z",
    fill: "#ffb64c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.008 302.016h-115c-8.284 0-15 6.716-15 15v195h130c8.284 0 15-6.716 15-15v-180c0-8.284-6.716-15-15-15z",
    fill: "#fed843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.008 512.016h-126v-255c0-8.284 6.716-15 15-15h111c8.284 0 15 6.716 15 15v240c0 8.284-6.716 15-15 15z",
    fill: "#ffb64c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.008 332.016c-8.284 0-15-6.716-15-15 0-24.813 20.187-45 45-45h60c8.271 0 15-6.729 15-15 0-24.813 20.187-45 45-45h60c8.271 0 15-6.729 15-15 0-8.284 6.716-15 15-15s15 6.716 15 15c0 24.813-20.187 45-45 45h-60c-8.271 0-15 6.729-15 15 0 24.813-20.187 45-45 45h-60c-8.271 0-15 6.729-15 15 0 8.284-6.716 15-15 15z",
    fill: "#efe2dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.688 126.206-50.28 12.79-17.97 48.67c-4.29 11.6-20.11 13.33-26.76 2.81l-27.69-43.87 83.46-144.56c4.64 2.67 7.89 7.75 7.48 13.95l-3.38 51.77 40.73 32.13c9.75 7.68 6.44 23.25-5.59 26.31z",
    fill: "#ffb64c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularity);
export default __webpack_public_path__ + "static/media/popularity.415f2e5d46c3d31999a23cd92f1cb723.svg";
export { ForwardRef as ReactComponent };